import type { ReactNode } from "react";

import { SidebarTrigger } from "@/components/ui/sidebar";

/** Shared topbar chrome. Portals pass their own right-hand actions. */
export function Topbar({ left, children }: { left?: ReactNode; children?: ReactNode }) {
  return (
    <header className="sticky top-0 z-30 flex h-16 items-center gap-3 border-b border-border bg-background/85 px-4 backdrop-blur-md sm:px-6">
      <SidebarTrigger className="text-muted-foreground" />
      {left}
      <div className="ml-auto flex items-center gap-2">{children}</div>
    </header>
  );
}
